import styled from 'styled-components';
import { useAppSelector, useAppDispatch } from '../hooks/useRedux';
import { Link, useNavigate } from 'react-router-dom';
import { logout } from '../store/authSlice';

const Container = styled.div`
	position: fixed;
	top: 75px;
	left: 0;
	width: 100vw;
	height: calc(100vh - 75px);
	overflow-y: scroll;
	background-color: #fff;
	z-index: 9999;
`;

const List = styled.div`
	cursor: pointer;
	box-sizing: border-box; // padding에 의한 스크롤 방지. border, padding을 width에 포함시켜주는 속성
	width: 100%;
	height: 4rem;
	border-top: 1px solid #dee2e6;
	padding: 0 1.4rem;
	font-size: 1.2rem;

	:last-child {
		border-bottom: 1px solid #dee2e6;
	}

	a {
		display: flex;
		align-items: center; // 텍스트를 수직 중앙에 배치합니다.
		width: 100%;
		height: 100%;
	}
`;

function ResponsiveMenu({ handleToggleMenu }: { handleToggleMenu: () => void }) {
	const isLogin = useAppSelector((state) => state.auth.isLogin);
	const dispatch = useAppDispatch();

	const navigate = useNavigate();

	return (
		<Container>
			<List onClick={handleToggleMenu}>
				<Link to='/exhibition'>Exhibition</Link>
			</List>
			<List onClick={handleToggleMenu}>
				<Link to='/artists'>Artists</Link>
			</List>
			<List onClick={handleToggleMenu}>
				<Link to='/goods'>Goods</Link>
			</List>
			{!isLogin ? (
				<>
					<List onClick={handleToggleMenu}>
						<Link to='/signup'>Sign Up</Link>
					</List>
					<List onClick={handleToggleMenu}>
						<Link to='/signin'>Sign In</Link>
					</List>
				</>
			) : (
				<>
					<List onClick={handleToggleMenu}>
						<Link to='/cart'>Cart</Link>
					</List>
					<List
						onClick={() => {
							handleToggleMenu();
							dispatch(logout());
							return navigate('/');
						}}
					>
						<Link>Sign Out</Link>
					</List>
				</>
			)}
		</Container>
	);
}

export default ResponsiveMenu;
